import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=5cb1d2fe"
import script from "./NewsList.vue?vue&type=script&lang=js"
export * from "./NewsList.vue?vue&type=script&lang=js"
import style0 from "./NewsList.vue?vue&type=style&index=0&id=5cb1d2fe&prod&lang=css"
import style1 from "./NewsList.vue?vue&type=style&index=1&id=5cb1d2fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports